export default __webpack_public_path__ + "static/media/bring_friends.3e096109.png";